import React from 'react';
import { get, getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Table, Whisper, Tooltip } from 'rsuite';
import { EllipsisText } from '../EllipsisText';

const { Cell } = Table;

const StyledTooltip = styled(Tooltip)`
  width: auto;
  z-index: 9 !important;
`;

export const NameCell = ({ valuePath, dataKey, rowData, ...props }) => {
  const path = valuePath ? `${valuePath}.` : '';
  const itemName = get(dataKey, rowData);
  const locationName = get(`${path}location.name`, rowData);
  const zone = getOr('', `${path}zone.name`, rowData);
  const locationZone = zone && `, ${zone}`;
  const location = `${locationName}${locationZone}`;

  const tooltip = (
    <StyledTooltip>
      <strong>{itemName}</strong>
      <br />
      {location}
    </StyledTooltip>
  );

  return (
    <Cell {...props}>
      <Whisper placement="topStart" trigger="click" speaker={tooltip}>
        <div>
          <EllipsisText style={{ fontSize: 15 }}>
            <strong>{itemName}</strong>
          </EllipsisText>
          <EllipsisText style={{ color: '#888' }}>{location}</EllipsisText>
        </div>
      </Whisper>
    </Cell>
  );
};

NameCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  valuePath: PropTypes.string,
  rowData: PropTypes.shape({})
};

NameCell.defaultProps = {
  rowData: null,
  valuePath: ''
};

export default NameCell;
